import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    makeStyles,
    Theme,
    Typography,
} from '@material-ui/core'
import React from 'react'
import AIDisclaimerIcon from 'resources/AIDisclaimerIcon'

interface AIDisclaimerDialogProps {
    open: boolean
    onClose: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            width: pxToRem(700),
            minWidth: pxToRem(700),
            color: theme.palette.common.black,
        },
    },
    title: {
        paddingBottom: theme.spacing(1),
        '& .MuiTypography-h6': {
            color: '#304959',
            fontSize: pxToRem(24),
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
        },
    },
    content: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
    },
    disclaimerText: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: pxToRem(14),
        lineHeight: pxToRem(20),
        marginBottom: theme.spacing(2),
    },
    disclaimerLabel: {
        fontWeight: 600,
    },
    actionContainer: {
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(2.5),
    },
    closeButton: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #0098D6',
        color: '#0098D6',
        borderRadius: pxToRem(100),
        fontSize: pxToRem(16),
        padding: theme.spacing(0.5, 1.85),
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#F5F5F5',
        },
    },
    icon: {
        fontSize: pxToRem(24),
    },
    divider: {
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
    },
}))

export const AIDisclaimerDialog = ({
    open,
    onClose,
}: AIDisclaimerDialogProps) => {
    const classes = useStyles()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            data-testid="ai-disclaimer-dialog"
            maxWidth="lg"
            className={classes.dialog}
        >
            <DialogTitle className={classes.title}>
                <AIDisclaimerIcon className={classes.icon} />
                AI Disclaimer
            </DialogTitle>
            <Divider className={classes.divider} />
            <DialogContent className={classes.content}>
                <Typography className={classes.disclaimerText}>
                    Customer's version of Specpoint BPM includes building Product Listings containing manufacturer data
                    extracted and structured using artificial intelligence from publicly available sources and combined with
                    proprietary Deltek data. Deltek does not independently verify its accuracy. Customer acknowledges that
                    product information may contain inaccuracies or errors and that Customer is responsible for independently
                    reviewing and verifying its accuracy. THE PRODUCT LISTINGS ARE PROVIDED STRICTLY ON AN "AS IS," "AS
                    AVAILABLE" BASIS, AND CUSTOMER'S USE IS AT CUSTOMER'S SOLE RISK. Deltek does not use customer-provided
                    project data to train AI features.
                </Typography>
                <Typography className={classes.disclaimerText}>
                    <span className={classes.disclaimerLabel}>Disclaimer:</span> Product Listings contain manufacturer data
                    extracted and structured by artificial intelligence from publicly available sources and proprietary Deltek
                    data. Deltek does not independently verify accuracy. Users should independently review and verify all
                    information. Product names, trademarks, and specifications are property of their respective manufacturers.
                    © 2026 Deltek, Inc.
                </Typography>
            </DialogContent>
            <Divider className={classes.divider} />
            <DialogActions className={classes.actionContainer}>
                <Button
                    data-testid="btn-close-ai-disclaimer"
                    disableRipple
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AIDisclaimerDialog
